import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LanguageStore {
  language: string;
  setLanguage: (language: string) => void;
}

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      language: "fr", // Valeur par défaut si rien n'est trouvé dans localStorage
      setLanguage: (language: string) => {
        set({ language });
      },
    }),
    {
      name: "language-storage", // Clé dans le localStorage
    }
  )
);
